var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDialog = function SvgDialog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#74CAFC",
    d: "M47.712 18.336C41.536 8.333 28.394 5.214 18.358 11.369s-13.165 19.253-6.99 29.256c.854 1.423-.149 3.19-1.01 4.595v.017L8.437 48.5a1.48 1.48 0 0 0-.01 1.481c.261.46.748.748 1.279.756h19.5c11.705-.002 21.297-9.26 21.673-20.92v-.028a21.17 21.17 0 0 0-3.168-11.454z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3DA1DB",
    d: "M23.573 39.598c6.176-10.002 19.318-13.122 29.354-6.967s13.165 19.254 6.99 29.257c-.854 1.422.147 3.189 1.009 4.592l.01.02 1.92 3.263c.268.459.27 1.025.007 1.486a1.5 1.5 0 0 1-1.286.751H42.08c-11.705-.004-21.295-9.263-21.673-20.922a21.2 21.2 0 0 1 3.166-11.48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D1B",
    d: "M69.854 21.06c-3.922-6.35-12.266-8.327-18.636-4.418-6.37 3.91-8.354 12.225-4.432 18.574.538.901-.094 2.018-.64 2.915v.01l-1.24 2.065a.94.94 0 0 0-.006.946.94.94 0 0 0 .822.472h12.373c7.428-.001 13.515-5.878 13.754-13.278v-.017a13.46 13.46 0 0 0-1.995-7.27z"
  }))));
};
export default SvgDialog;